/* eslint react/prop-types: 0 */
import { css } from '@emotion/react';
import {
  ErrorMessage,
  SuccessMessageFull,
  NotificationMessage,
} from '@hotjar/webapp/components/Message';

const notificationStyles = css`
  color: white;
  position: fixed;
  right: 20px;
  bottom: 20px;
  pointer-events: none;
  transition: opacity 0.4s;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  max-width: 420px;
  padding: 11px 20px 11px 14px;
  z-index: 900001 !important;
`;

export const ErrorNotification = ({ show, children }) => (
  <ErrorMessage
    css={[
      notificationStyles,
      css`
        opacity: ${show ? 1 : 0};
      `,
    ]}
  >
    {children}
  </ErrorMessage>
);

export const Notification = ({ show, children }) => (
  <NotificationMessage
    css={[
      notificationStyles,
      css`
        opacity: ${show ? 1 : 0};
      `,
    ]}
  >
    {children}
  </NotificationMessage>
);

export const SuccessNotification = ({ show, children }) => (
  <SuccessMessageFull
    css={[
      notificationStyles,
      css`
        opacity: ${show ? 1 : 0};
      `,
    ]}
  >
    {children}
  </SuccessMessageFull>
);
